"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileToDataURL = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
        resolve(reader.result);
    });
    reader.addEventListener('error', error => {
        reject(error);
    });
    reader.readAsDataURL(file);
});
exports.loadImage = (src) => new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => {
        resolve(img);
    };
    img.onerror = err => {
        // The image couldn't be loaded.
        reject(err);
    };
    img.src = src;
});
//# sourceMappingURL=Utils.js.map